import { redoCartCheckoutIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

// Starts a ledger-billed supplies checkout: creates (or returns the existing)
// active redo_cart_checkout for the merchant's active cart. Distinct from
// createCheckoutSession, which builds a Stripe embedded checkout session.
export const startSuppliesCheckout = {
  name: "startSuppliesCheckout" as const,
  input: z.object({}),
  output: z.object({ checkoutId: redoCartCheckoutIdFormat.schema }),
};
